var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-filter',{attrs:{"filterComponents":[
      {
        type: 'TakeFilter',
        name: 'take'
      },
      {
        type: 'WhereFilter',
        label: 'ID',
        attributes: 'user_id'
      },
      {
        type: 'WhereLikeFilter',
        label: 'Name',
        attributes: 'user.name'
      }
    ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('v-table',{attrs:{"url":"/api/v1/userSession","filter":_vm.filter,"attributes":[
      {
        attribute: 'user.name',
        name: 'Name',
        sortable: false
      },
      {
        attribute: 'created_at',
        name: 'Datum',
        type: 'DateTimeCell',
        sortable: false
      },
      {
        attribute: 'ip',
        name: 'IP-Adresse'
      },
      {
        attribute: 'country_code',
        name: 'Land',
        type: 'FlagCell',
        sortable: false
      },
      {
        attribute: 'session_id',
        name: 'Session-ID'
      },
      {
        attribute: 'user_agent',
        name: 'Browser- und Gerätedaten'
      },
      {
        attribute: 'role_name',
        name: 'Rolle',
        sortable: false
      },
      {
        attribute: 'duration',
        name: 'Zeitspanne',
        sortable: false
      },
      {
        attribute: 'success',
        name: 'Erfolgreich eingeloggt',
        type: 'CheckMarkerCell'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Anmeldungen")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }